import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ModalConfig, UiTranslateLoaderService } from 'ui-shared';
import { OrganizationSelectionListComponent } from './organization-selection-list.component';
import { OrganizationDefinitionModel } from '../model/organization-definition-model';
import { OrganizationDefinitionQueryModel } from '../model/organization-definition-query-model';

@Component({
    selector: 'organization-picker',
    templateUrl: './organization-picker.component.html',
    styleUrls: ['./organization-picker.component.scss'],
})
export class OrganizationPickerComponent {
    dynamicDialogRef: DynamicDialogRef;

    @Input() selectionMode: string = 'single';
    @Input() organizationPicker: OrganizationDefinitionModel[] = [];
    @Input() disabled: boolean = false;
    @Output() valueEvent = new EventEmitter<any>();
    @Output() organizationPickerChange = new EventEmitter<any>();
    @Input() showStaffFullnessStatus = true;
    @Input() queryModel: OrganizationDefinitionQueryModel;
    @Input() dataKey: string = 'perObjectDefinitionId';
    organizationPickerText = [];
    @Input() showCountOnly: boolean = false;

    constructor(
        private dialogService: DialogService,
        protected translateService: UiTranslateLoaderService,
    ) {}

    onShow() {
        this.dynamicDialogRef = this.dialogService.open(OrganizationSelectionListComponent, {
            width: ModalConfig.MODAL_WIDTH,
            header: this.translateService.instant('hrPerOrganizationGeneralInfo.organizationSelection'),
            contentStyle: {
                height: ModalConfig.MODAL_MAX_HEIGHT,
                'max-height': ModalConfig.MODAL_MAX_HEIGHT,
                overflow: 'hidden',
            },
            data: {
                selectionMode: this.selectionMode,
                orgPickerData: this.organizationPicker,
                showStaffFullnessStatus: this.showStaffFullnessStatus,
                queryModel: this.queryModel,
                dataKey: this.dataKey,
            },
        });

        this.dynamicDialogRef.onClose.subscribe((model) => {
            if (model) {
                if (this.selectionMode == 'single') {
                    this.organizationPicker = [model];
                } else {
                    this.organizationPicker = model;
                }

                //this.organizationPickerChange.emit(model.perObjectDefinitionText);
                this.valueEvent.emit(model);
            }
        });
    }

    onRemove() {
        this.organizationPicker = [];
        this.valueEvent.emit([]);
    }
}
